import React from 'react';
import { IconButton, Icon } from '../styles';

const Button = ({
  onClick, disabled, btnHeight, btnWidth, btnIcon, iconWidth, iconHeight,
}) => (
  <IconButton onClick={onClick} disabled={disabled} btnWidth={btnWidth} btnHeight={btnHeight}>
    <Icon src={btnIcon} iconWidth={iconWidth} iconHeight={iconHeight} />
  </IconButton>
);

export default Button;
